export type Question = {
    name: string;
    label: string;
};

export type CoreHealthQuestions = {
    [category: string]: Question[];
};

export const coreHealthQuestions: CoreHealthQuestions = {
    highBloodPressure: [
        {
            name: 'Bloodpressure',
            label: 'Blood pressure',
        },
    ],
    cholesterol: [
        {
            name: 'Cholesterol',
            label: 'Cholesterol',
        },
    ],
    diabetes: [
        {
            name: 'Type1Diabetes',
            label: 'Type 1 Diabetes',
        },
        {
            name: 'Type2Diabetes',
            label: 'Type 2 Diabetes',
        },
        {
            name: 'Hypoglycemia',
            label: 'Hypoglycemia',
        },
    ],
    psychologicalDisorder: [
        {
            name: 'Anxiety',
            label: 'Anxiety',
        },
        {
            name: 'Depression',
            label: 'Depression',
        },
        {
            name: 'BipolarDisorder',
            label: 'Bipolar Disorder',
        },
        {
            name: 'Schizophrenia',
            label: 'Schizophrenia',
        },
        {
            name: 'ADDADHD',
            label: 'ADD/ADHD',
        },
        {
            name: 'AutismSpectrumDisorder',
            label: 'Autism Spectrum Disorder',
        },
    ],
    bonemuscle: [
        {
            name: 'OsteoArthritis',
            label: 'Osteo - Arthritis',
        },
        {
            name: 'RheumatoidArthritis',
            label: 'Rheumatoid Arthritis',
        },
        {
            name: 'Osteoperosis',
            label: 'Osteoperosis',
        },
        {
            name: 'EnlargedProstateBenignProstaticHyperplasia',
            label: 'Enlarged Prostate / Benign Prostatic Hyperplasia',
        },
        {
            name: 'Gout',
            label: 'Gout',
        },
        {
            name: 'MSMultipleSclerosis',
            label: 'MS (Multiple Sclerosis)',
        },
        {
            name: 'Fibromyalgia',
            label: 'Fibromyalgia',
        },
        {
            name: 'Hyperthyroidism',
            label: 'Hyperthyroidism',
        },
        {
            name: 'Hypothyroidism',
            label: 'Hypothyroidism',
        },
        {
            name: 'LiverDisease',
            label: 'Liver Disease',
        },
        {
            name: 'KidneyDisorderKidneyDisease',
            label: 'Kidney Disorder / Kidney Disease',
        },
        {
            name: 'Lupus',
            label: 'Lupus',
        },
    ],
    health: [
        {
            name: 'Herpes',
            label: 'Herpes',
        },
        {
            name: 'KidneyStones',
            label: 'Kidney Stones',
        },
        {
            name: 'Insomnia',
            label: 'Insomnia',
        },
        {
            name: 'Pneumonia',
            label: 'Pneumonia',
        },
        {
            name: 'BloodClotinthelungsPulmonaryEmbolism',
            label: 'Blood Clot in the lungs (Pulmonary Embolism)',
        },
        {
            name: 'Bronchitis',
            label: 'Bronchitis',
        },
        {
            name: 'UTIUrinaryTractInfection',
            label: 'UTI (Urinary Tract Infection)',
        },
        {
            name: 'Sexuallytransmitteddiseases',
            label: 'Sexually transmitted diseases',
        },
        {
            name: 'Conjuctiva',
            label: 'Conjuctiva',
        },
        {
            name: 'MuscleSpasms',
            label: 'Muscle Spasms',
        },
        {
            name: 'StaphInfection',
            label: 'Staph Infection',
        },
        {
            name: 'CoronavirusCovid19',
            label: 'Coronavirus / Covid-19',
        },
        {
            name: 'Eczema',
            label: 'Eczema',
        },
        {
            name: 'HIVAIDS',
            label: 'HIV / AIDS',
        },
        {
            name: 'Glaucoma',
            label: 'Glaucoma',
        },
        {
            name: 'OpioidAddiction',
            label: 'Opioid Addiction',
        },
        {
            name: 'AllergiesHayFever',
            label: 'Allergies / Hay Fever',
        },
        {
            name: 'YeastInfection',
            label: 'Yeast Infection',
        },
        {
            name: 'PainMedication',
            label: 'Pain Medication',
        },
        {
            name: 'MuscleRelaxant',
            label: 'Muscle Relaxant',
        },
        {
            name: 'HeadachesMigraines',
            label: 'Headaches / Migraines',
        },
        {
            name: 'HBVHepatitisBVirus',
            label: 'HBV (Hepatitis B Virus)',
        },
        {
            name: 'HCVHepatitisCVirus',
            label: 'HCV (Hepatitis C Virus)',
        },
        {
            name: 'Anemia',
            label: 'Anemia',
        },
        {
            name: 'Menopause',
            label: 'Menopause',
        },
        {
            name: 'TuberculosisTB',
            label: 'Tuberculosis (TB)',
        },
        {
            name: 'LeftBundleBranchBlock',
            label: 'Left Bundle Branch Block',
        },
        {
            name: 'RightBundleBranchBlock',
            label: 'Right Bundle Branch Block',
        },
        {
            name: 'Diarrhea',
            label: 'Diarrhea',
        },
        {
            name: 'Meningitis',
            label: 'Meningitis',
        },
        {
            name: 'AddisonsDisease',
            label: "Addison's Disease",
        },
        {
            name: 'AdrenogenitalSyndrome',
            label: 'Adrenogenital Syndrome',
        },
        {
            name: 'Bulimia',
            label: 'Bulimia',
        },
        {
            name: 'OCDObsessiveCompulsiveDisorder',
            label: 'OCD (Obsessive-Compulsive Disorder)',
        },
        {
            name: 'PagetsDisease',
            label: "Paget's Disease",
        },
        {
            name: 'BladderInfection',
            label: 'Bladder Infection',
        },
        {
            name: 'RestlessLegSyndromeRLS',
            label: 'Restless Leg Syndrome (RLS)',
        },
        {
            name: 'BacterialInfection',
            label: 'Bacterial Infection',
        },
        {
            name: 'CysticFibrosis',
            label: 'Cystic Fibrosis',
        },
        {
            name: 'Nausea',
            label: 'Nausea',
        },
        {
            name: 'TourettesSyndrome',
            label: "Tourette's Syndrome",
        },
        {
            name: 'Malaria',
            label: 'Malaria',
        },
        {
            name: 'HPV',
            label: 'HPV',
        },
        {
            name: 'Emphysema',
            label: 'Emphysema',
        },
        {
            name: 'TardiveDyskinesia',
            label: 'Tardive Dyskinesia',
        },
        {
            name: 'Acne',
            label: 'Acne',
        },
        {
            name: 'FungalInfection',
            label: 'Fungal Infection',
        },
        {
            name: 'BirthControl',
            label: 'Birth Control',
        },
        {
            name: 'Myelofibrosis',
            label: 'Myelofibrosis',
        },
        {
            name: 'HormoneReplacementTherapy',
            label: 'Hormone Replacement Therapy',
        },
        {
            name: 'Endometriosis',
            label: 'Endometriosis',
        },
        {
            name: 'Hyperkalemia',
            label: 'Hyperkalemia',
        },
        {
            name: 'PanicDisorder',
            label: 'Panic Disorder',
        },
        {
            name: 'MultipleMyeloma',
            label: 'Multiple Myeloma',
        },
        {
            name: 'Constipation',
            label: 'Constipation',
        },
        {
            name: 'OveractiveBladder',
            label: 'Overactive Bladder',
        },
        {
            name: 'OpioidEmergency',
            label: 'Opioid Emergency',
        },
        {
            name: 'Neutropenia',
            label: 'Neutropenia',
        },
        {
            name: 'IdiopathicPulmonaryFibrosisIPF',
            label: 'Idiopathic Pulmonary Fibrosis (IPF)',
        },
        {
            name: 'WeightLossObesityGastric',
            label: 'Weight Loss / Obesity/Gastric',
        },
        {
            name: 'InfluenzaFlu',
            label: 'Influenza / Flu',
        },
        {
            name: 'PostTraumaticStressDisorderPTSD',
            label: 'Post Traumatic Stress Disorder (PTSD)',
        },
        {
            name: 'Hypokalemia',
            label: 'Hypokalemia',
        },
        {
            name: 'Congestion',
            label: 'Congestion',
        },
        {
            name: 'ExcessiveUnderarmSweating',
            label: 'Excessive Underarm Sweating',
        },
        {
            name: 'Tumor',
            label: 'Tumor',
        },
        {
            name: 'HeartArrythmia',
            label: 'Heart Arrythmia',
        },
        {
            name: 'Shingles',
            label: 'Shingles',
        },
        {
            name: 'ChronicDryEye',
            label: 'Chronic Dry Eye',
        },
        {
            name: 'TetanusLockjaw',
            label: 'Tetanus (Lockjaw)',
        },
        {
            name: 'ErectileDysfunction',
            label: 'Erectile Dysfunction',
        },
        {
            name: 'Transplant',
            label: 'Transplant',
        },
        {
            name: 'Cough',
            label: 'Cough',
        },
        {
            name: 'CirrhosisoftheLiver',
            label: 'Cirrhosis of the Liver',
        },
        {
            name: 'UrinaryRetention',
            label: 'Urinary Retention',
        },
        {
            name: 'Gallstones',
            label: 'Gallstones',
        },
        {
            name: 'SmokingCessationQuitSmoking',
            label: 'Smoking Cessation / Quit Smoking',
        },
        {
            name: 'EatingDisorder',
            label: 'Eating Disorder',
        },
        {
            name: 'ChronicHives',
            label: 'Chronic Hives',
        },
        {
            name: 'Polyps',
            label: 'Polyps',
        },
        {
            name: 'ObstructiveAirwayDisease',
            label: 'Obstructive Airway Disease',
        },
        {
            name: 'Cataplexy',
            label: 'Cataplexy',
        },
        {
            name: 'PleuralMesothelioma',
            label: 'Pleural Mesothelioma',
        },
    ],
    nervousSystemDisorder: [
        {
            name: 'Narcolepsy',
            label: 'Narcolepsy',
        },
        {
            name: 'ParkinsonsDisease',
            label: "Parkinson's Disease",
        },
        {
            name: 'DementiaAlzheimers',
            label: "Dementia / Alzheimer's",
        },
        {
            name: 'SeizuresEpilepsyPetitMal',
            label: 'Seizures / Epilepsy - Petit Mal',
        },
        {
            name: 'SeizuresEpilepsyGrandMal',
            label: 'Seizures / Epilepsy - Grand Mal',
        },
    ],
    respiratoryDisorder: [
        {
            name: 'Asthma',
            label: 'Asthma',
        },
        {
            name: 'COPD',
            label: 'COPD',
        },
    ],
    sleepApnea: [
        {
            name: 'SleepApnea',
            label: 'Sleep Apnea',
        },
    ],
    heartDisease: [
        {
            name: 'HeartFailure',
            label: 'Heart Failure',
        },
    ],
    digestiveSystemDisorder: [
        {
            name: 'IBSIrritableBowelSyndrome',
            label: 'IBS (Irritable Bowel Syndrome)',
        },
        {
            name: 'CrohnsDisease',
            label: "Crohn's Disease",
        },
        {
            name: 'Ulcers',
            label: 'Ulcers',
        },
        {
            name: 'UlcerativeColitis',
            label: 'Ulcerative Colitis',
        },
        {
            name: 'GERDHeartburn',
            label: 'GERD / Heartburn',
        },
    ],
    cancerOrTumors: [
        {
            name: 'BreastCancer',
            label: 'Breast Cancer',
        },
        {
            name: 'ProstateCancer',
            label: 'Prostate Cancer',
        },
        {
            name: 'Cancer',
            label: 'Cancer',
        },
        {
            name: 'Leukemia',
            label: 'Leukemia',
        },
        {
            name: 'SkinCancerMelanoma',
            label: 'Skin Cancer (Melanoma)',
        },
        {
            name: 'OvarianCancer',
            label: 'Ovarian Cancer',
        },
        {
            name: 'Lymphoma',
            label: 'Lymphoma',
        },
        {
            name: 'BasalCellCarcinoma',
            label: 'Basal Cell Carcinoma',
        },
    ],
    stroke: [
        {
            name: 'Stroke',
            label: 'Stroke',
        },
    ],
    others: [
        {
            name: 'VentricularTachycardia',
            label: 'Ventricular Tachycardia',
        },
        {
            name: 'VentricularFibrillation',
            label: 'Ventricular Fibrillation',
        },
        {
            name: 'AtrialFibulationAfib',
            label: 'Atrial Fibrillation (Afib)',
        },
        {
            name: 'BloodClotDVTDeepVeinThrombosis',
            label: 'Blood Clot (DVT - Deep Vein Thrombosis)',
        },
        {
            name: 'Psoriasis',
            label: 'Psoriasis',
        },
        {
            name: 'AnginaChestPain',
            label: 'Angina / Chest Pain',
        },
        {
            name: 'AVBlock',
            label: 'AV Block',
        },
        {
            name: 'Defibrillator',
            label: 'Defibrillator',
        },
    ],
};
